import { z } from "zod";

const errorMessages = {
  required: "وارد کردن این فیلد اجباری است",
};

const schema = z.object({
  count_semesters: z.string().min(1, errorMessages.required),
  fee: z.string().min(1, errorMessages.required),
  semesters_year: z.string().min(1, errorMessages.required),
  semesters_season: z.string().min(1, errorMessages.required),
  register_start_date: z.string().min(1, errorMessages.required),
  register_end_date: z.string().min(1, errorMessages.required),
  start_program_date: z.string().min(1, errorMessages.required),
});

export { schema };
